<template>
    <div class="myData_container">
        <van-tabs v-model:active="active" sticky :ellipsis="false" @click-tab="setTab()">
            <van-tab v-for="(item, index) in tabList" :key="index" :title="$t(item.name)" :name="index">
                <div class="content">
                    <div class="timeRange_card">
                        <img src="@/assets/agent/yuce_bai.png" alt="">
                        {{ formatUnixTimestamp(myData.start_time) + " - " + formatUnixTimestamp(myData.end_time) }}
                    </div>
                    <TotalCard :title1="$t('myDataView.directCommision')" :title2="$t('myDataView.teamCommission')"
                        :title3="$t('myDataView.totalCommssion')" rightText1="R$"
                        :value1="formatCurrency(myData.user_data.direct_commission)"
                        :value2="formatCurrency(myData.user_data.team_commission)"
                        :value3="formatCurrency(myData.user_data.total_commission)" />
                    <TotalCard :title1="$t('myDataView.bets')" :title2="$t('myDataView.teamBets')"
                        :title3="$t('myDataView.totalBets')" rightText1="R$"
                        :value1="formatCurrency(myData.user_data.direct_bet)"
                        :value2="formatCurrency(myData.user_data.team_bet)"
                        :value3="formatCurrency(myData.user_data.total_bet)" />
                    <TotalCard :title1="$t('myDataView.recharge')" :title2="$t('myDataView.teamRecharge')"
                        :title3="$t('myDataView.totalRecharge')" rightText1="R$"
                        :value1="formatCurrency(myData.user_data.direct_recharge)"
                        :value2="formatCurrency(myData.user_data.team_recharge)"
                        :value3="formatCurrency(myData.user_data.total_recharge)" />
                    <TotalCard :title1="$t('myDataView.registration')" :title2="$t('myDataView.teamRegistration')"
                        :title3="$t('myDataView.totalRecords')" :rightText2="$t('common.pepole')"
                        :value1="myData.user_data.new_direct_user_count" :value2="myData.user_data.new_team_user_count"
                        :value3="myData.user_data.new_user_count" />
                    <TotalCard :title1="$t('myDataView.firstDirectCommission')"
                        :title2="$t('myDataView.teamsFirstDeposit')" :rightText2="$t('common.pepole')"
                        :title3="$t('myDataView.totalInitialDepost')"
                        :value1="myData.user_data.new_direct_first_recharge_count"
                        :value2="myData.user_data.new_team_first_recharge_count"
                        :value3="myData.user_data.new_first_recharge_count" />
                </div>
            </van-tab>
        </van-tabs>
        <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
        <LoadingScreen ref="loadingRef" />
    </div>
</template>

<script setup lang="ts">
import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';
import { onMounted, ref } from 'vue';
import TotalCard from './totalCard.vue';
import { useI18n } from 'vue-i18n';
import { getMyData } from '@/api/agent';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { MY_DATA_TAB_LIST, getMyDataListFunc, UserData, MyDataItem } from '@/view/agent/supportScript';
const { t } = useI18n();
const myData = ref<MyDataItem>({
    start_time: 0,
    end_time: 0,
    user_data: {
        direct_commission: 0,
        total_commission: 0,
        direct_bet: 0,
        total_bet: 0,
        new_direct_user_count: 0,
        new_user_count: 0,
        direct_recharge: 0,
        total_recharge: 0,
        new_direct_first_recharge_count: 0,
        new_first_recharge_count: 0,
        team_commission: 0,
        team_bet: 0,
        team_recharge: 0,
        new_team_user_count: 0,
        new_team_first_recharge_count: 0
    }
});
const active = ref(0)
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()
const tabList = ref(MY_DATA_TAB_LIST)

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getMyDataList = () => {
      getMyDataListFunc(getMyData, active, myData, loadingRef, showError)
}

const setTab = () => {
    loadingRef.value.open()
    getMyDataList();

}
onMounted(() => {
    loadingRef.value.open()
    getMyDataList()
})

</script>
<style scoped>
.myData_container {
    padding: 15px;
}

.myData_container>>>.van-tabs__nav {
    background: transparent;
    padding: 0;
}

.myData_container>>>.van-tab {
    color: rgba(255, 255, 255, 0.85);
    background: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    font-weight: 200;
    font-size: 13px;
    margin: 0 5px;
    padding: 0 10px;
    height: 40px;
}

.myData_container>>>.van-tab.van-tab--active {
    background: #F0A853;
    color: rgba(0, 0, 0, 0.85);
}

.myData_container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

.timeRange_card {
    border-radius: 10px;
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.25) 100%);
    padding: 15px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 5px 0;
}

.timeRange_card img {
    width: 20px;
    opacity: 0.45;
    margin: 0 10px;
}
</style>